import * as z from "zod";
import { userFacingError } from "../authorization";
import { grantsForScope } from "../rbac/grantQueries";
import { mutator } from "./mutator";

const tidyUpFreshConnectorSchema = z.object({
  connectedAppId: z.string(),
});

export const tidyUpFreshConnectedApp = mutator({
  schema: tidyUpFreshConnectorSchema,
  resolve: {
    app: { kind: "connectedApp", from: "connectedAppId" },
  },
  permissions: [
    {
      permission: "connected_app:write",
      scopeId: ({ args }) => args.app.id,
    },
  ],
  fn: async ({ tx, args: { app } }) => {
    if (!app.fresh) {
      throw userFacingError("Connector has already been saved.");
    }

    const grants = await tx.run(grantsForScope(app.id, app.tenantId));
    for (const g of grants) {
      await tx.mutate.roleGrants.delete({ id: g.id });
    }

    await tx.mutate.connectedApps.delete({ id: app.id });
    if (app.oauthConnectionId) {
      await tx.mutate.oauthConnections.delete({ id: app.oauthConnectionId });
    }
  },
});
